// extracted by mini-css-extract-plugin
export var cardWrapper = "style-module--card-wrapper--d9291";
export var content = "style-module--content--8848c";
export var heading = "style-module--heading--9d5aa";